import { useEffect, useRef } from 'react';

export const useActiveOptionScroll = ({ isOpen, panelRef }) => {
  const activeOptionRef = useRef(null);

  // Scroll to active option
  useEffect(() => {
    if (isOpen && activeOptionRef.current && panelRef?.current) {
      setTimeout(() => {
        const activeOption = activeOptionRef.current;
        if (activeOption) {
          activeOption.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, 300);
    }
  }, [isOpen, panelRef]);

  return { activeOptionRef };
};
